module.exports = __webpack_public_path__ + "static/logos-05-06128c57cbe82931e00a1d5f4a06b105.png";